import PropTypes from 'prop-types'

const SelectedThemeProviderPropTypes = {
  children: PropTypes.node.isRequired
}

export default SelectedThemeProviderPropTypes
